let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bxYOE")).then(() => parcelRequire('f6K6R'));